export default __webpack_public_path__ + "static/media/Piadine.d275948c.jpg";